module.exports = __webpack_public_path__ + "media/images/features/7/main-1-58252e0c712d9a661a6930ccbc8c44a3.jpg";